import React, { useEffect, useState } from 'react'

const CoinLogo = ({ src, symbol = '', size = 36 }) => {
  const [failed, setFailed] = useState(false)

  useEffect(() => {
    setFailed(false)
  }, [src])

  const letter = String(symbol).trim().charAt(0).toUpperCase() || '?'

  if (!src || failed) {
    return (
      <div
        className='mk-coin-fallback'
        style={{ width: size, height: size, fontSize: size * 0.42 }}
      >
        {letter}
      </div>
    )
  }

  return (
    <img
      src={src}
      alt={symbol || 'coin'}
      loading='lazy'
      draggable={false}
      className='mk-coin-img'
      style={{ width: size, height: size, pointerEvents: 'none', userSelect: 'none', WebkitUserDrag: 'none', }}
      onError={() => setFailed(true)}
    />
  )
}

export default CoinLogo